export default {
    topics: [
        {
            title: ' AppendDeliveryPart ',
            href: 'sm-delivery-AppendDeliveryPart.html',
            attributes: { 'data-id': 'sm-delivery-AppendDeliveryPart' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-AppendDeliveryPart-d66e2319',
            topics: [],
        },
        {
            title: ' BuildForward ',
            href: 'sm-delivery-BuildForward.html',
            attributes: { 'data-id': 'sm-delivery-BuildForward' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-BuildForward-d66e2327',
            topics: [],
        },
        {
            title: ' BuildMirror ',
            href: 'sm-delivery-BuildMirror.html',
            attributes: { 'data-id': 'sm-delivery-BuildMirror' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-BuildMirror-d66e2335',
            topics: [],
        },
        {
            title: ' BuildMirrorEx ',
            href: 'sm-delivery-BuildMirrorEx.html',
            attributes: { 'data-id': 'sm-delivery-BuildMirrorEx' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-BuildMirrorEx-d66e2343',
            topics: [],
        },
        {
            title: ' BuildPreview ',
            href: 'sm-delivery-BuildPreview.html',
            attributes: { 'data-id': 'sm-delivery-BuildPreview' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-BuildPreview-d66e2351',
            topics: [],
        },
        {
            title: ' BuildPreviewFromId ',
            href: 'sm-delivery-BuildPreviewFromId.html',
            attributes: { 'data-id': 'sm-delivery-BuildPreviewFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-BuildPreviewFromId-d66e2359',
            topics: [],
        },
        {
            title: ' BuildTargetDataSchema ',
            href: 'sm-delivery-BuildTargetDataSchema.html',
            attributes: { 'data-id': 'sm-delivery-BuildTargetDataSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-BuildTargetDataSchema-d66e2367',
            topics: [],
        },
        {
            title: ' CleanupDeliveries ',
            href: 'sm-delivery-CleanupDeliveries.html',
            attributes: { 'data-id': 'sm-delivery-CleanupDeliveries' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-CleanupDeliveries-d66e2375',
            topics: [],
        },
        {
            title: ' CollectLogs ',
            href: 'sm-delivery-CollectLogs.html',
            attributes: { 'data-id': 'sm-delivery-CollectLogs' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-CollectLogs-d66e2383',
            topics: [],
        },
        {
            title: ' CreateFromModel ',
            href: 'sm-delivery-CreateFromModel.html',
            attributes: { 'data-id': 'sm-delivery-CreateFromModel' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-CreateFromModel-d66e2391',
            topics: [],
        },
        {
            title: ' DeployTriggerMessageSingle ',
            href: 'sm-delivery-DeployTriggerMessageSingle.html',
            attributes: { 'data-id': 'sm-delivery-DeployTriggerMessageSingle' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-DeployTriggerMessageSingle-d66e2400',
            topics: [],
        },
        {
            title: ' DeployTriggerMessages ',
            href: 'sm-delivery-DeployTriggerMessages.html',
            attributes: { 'data-id': 'sm-delivery-DeployTriggerMessages' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-DeployTriggerMessages-d66e2408',
            topics: [],
        },
        {
            title: ' DiagnoseHTML ',
            href: 'sm-delivery-DiagnoseHTML.html',
            attributes: { 'data-id': 'sm-delivery-DiagnoseHTML' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-DiagnoseHTML-d66e2416',
            topics: [],
        },
        {
            title: ' DispatchImages ',
            href: 'sm-delivery-DispatchImages.html',
            attributes: { 'data-id': 'sm-delivery-DispatchImages' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-DispatchImages-d66e2424',
            topics: [],
        },
        {
            title: ' ExecCommand ',
            href: 'sm-delivery-ExecCommand.html',
            attributes: { 'data-id': 'sm-delivery-ExecCommand' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-ExecCommand-d66e2432',
            topics: [],
        },
        {
            title: ' ExecuteJob ',
            href: 'sm-delivery-ExecuteJob.html',
            attributes: { 'data-id': 'sm-delivery-ExecuteJob' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-ExecuteJob-d66e2440',
            topics: [],
        },
        {
            title: ' FinalizeMidPreparation ',
            href: 'sm-delivery-FinalizeMidPreparation.html',
            attributes: { 'data-id': 'sm-delivery-FinalizeMidPreparation' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-FinalizeMidPreparation-d66e2448',
            topics: [],
        },
        {
            title: ' GetDeviceList ',
            href: 'sm-delivery-GetDeviceList.html',
            attributes: { 'data-id': 'sm-delivery-GetDeviceList' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetDeviceList-d66e2456',
            topics: [],
        },
        {
            title: ' GetDlStatusAndLogs ',
            href: 'sm-delivery-GetDlStatusAndLogs.html',
            attributes: { 'data-id': 'sm-delivery-GetDlStatusAndLogs' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetDlStatusAndLogs-d66e2464',
            topics: [],
        },
        {
            title: ' GetFilesToDownload ',
            href: 'sm-delivery-GetFilesToDownload.html',
            attributes: { 'data-id': 'sm-delivery-GetFilesToDownload' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetFilesToDownload-d66e2472',
            topics: [],
        },
        {
            title: ' GetMidBroadLogs ',
            href: 'sm-delivery-GetMidBroadLogs.html',
            attributes: { 'data-id': 'sm-delivery-GetMidBroadLogs' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetMidBroadLogs-d66e2480',
            topics: [],
        },
        {
            title: ' GetMidDeliveries ',
            href: 'sm-delivery-GetMidDeliveries.html',
            attributes: { 'data-id': 'sm-delivery-GetMidDeliveries' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetMidDeliveries-d66e2489',
            topics: [],
        },
        {
            title: ' GetMidXtkKey ',
            href: 'sm-delivery-GetMidXtkKey.html',
            attributes: { 'data-id': 'sm-delivery-GetMidXtkKey' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetMidXtkKey-d66e2497',
            topics: [],
        },
        {
            title: ' GetMirrorURL ',
            href: 'sm-delivery-GetMirrorURL.html',
            attributes: { 'data-id': 'sm-delivery-GetMirrorURL' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetMirrorURL-d66e2505',
            topics: [],
        },
        {
            title: ' GetSeedList ',
            href: 'sm-delivery-GetSeedList.html',
            attributes: { 'data-id': 'sm-delivery-GetSeedList' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-GetSeedList-d66e2513',
            topics: [],
        },
        {
            title: ' HtmlToText ',
            href: 'sm-delivery-HtmlToText.html',
            attributes: { 'data-id': 'sm-delivery-HtmlToText' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-HtmlToText-d66e2521',
            topics: [],
        },
        {
            title: ' ImagePublishing ',
            href: 'sm-delivery-ImagePublishing.html',
            attributes: { 'data-id': 'sm-delivery-ImagePublishing' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-ImagePublishing-d66e2529',
            topics: [],
        },
        {
            title: ' InstallTransactionalMessage ',
            href: 'sm-delivery-InstallTransactionalMessage.html',
            attributes: { 'data-id': 'sm-delivery-InstallTransactionalMessage' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-InstallTransactionalMessage-d66e2537',
            topics: [],
        },
        {
            title: ' InvalidateDeliveryCache ',
            href: 'sm-delivery-InvalidateDeliveryCache.html',
            attributes: { 'data-id': 'sm-delivery-InvalidateDeliveryCache' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-InvalidateDeliveryCache-d66e2545',
            topics: [],
        },
        {
            title: ' LaunchFCP ',
            href: 'sm-delivery-LaunchFCP.html',
            attributes: { 'data-id': 'sm-delivery-LaunchFCP' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-LaunchFCP-d66e2553',
            topics: [],
        },
        {
            title: ' LoadExpandedContents ',
            href: 'sm-delivery-LoadExpandedContents.html',
            attributes: { 'data-id': 'sm-delivery-LoadExpandedContents' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-LoadExpandedContents-d66e2561',
            topics: [],
        },
        {
            title: ' Pause ',
            href: 'sm-delivery-Pause.html',
            attributes: { 'data-id': 'sm-delivery-Pause' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-Pause-d66e2569',
            topics: [],
        },
        {
            title: ' Play ',
            href: 'sm-delivery-Play.html',
            attributes: { 'data-id': 'sm-delivery-Play' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-Play-d66e2578',
            topics: [],
        },
        {
            title: ' Prepare ',
            href: 'sm-delivery-Prepare.html',
            attributes: { 'data-id': 'sm-delivery-Prepare' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-Prepare-d66e2586',
            topics: [],
        },
        {
            title: ' PrepareAndStart ',
            href: 'sm-delivery-PrepareAndStart.html',
            attributes: { 'data-id': 'sm-delivery-PrepareAndStart' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareAndStart-d66e2594',
            topics: [],
        },
        {
            title: ' PrepareFromId ',
            href: 'sm-delivery-PrepareFromId.html',
            attributes: { 'data-id': 'sm-delivery-PrepareFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareFromId-d66e2602',
            topics: [],
        },
        {
            title: ' PrepareMessage ',
            href: 'sm-delivery-PrepareMessage.html',
            attributes: { 'data-id': 'sm-delivery-PrepareMessage' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareMessage-d66e2610',
            topics: [],
        },
        {
            title: ' PrepareMessageImpl ',
            href: 'sm-delivery-PrepareMessageImpl.html',
            attributes: { 'data-id': 'sm-delivery-PrepareMessageImpl' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareMessageImpl-d66e2618',
            topics: [],
        },
        {
            title: ' PrepareMultipartRelated ',
            href: 'sm-delivery-PrepareMultipartRelated.html',
            attributes: { 'data-id': 'sm-delivery-PrepareMultipartRelated' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareMultipartRelated-d66e2626',
            topics: [],
        },
        {
            title: ' PrepareNotification ',
            href: 'sm-delivery-PrepareNotification.html',
            attributes: { 'data-id': 'sm-delivery-PrepareNotification' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareNotification-d66e2634',
            topics: [],
        },
        {
            title: ' PrepareProof ',
            href: 'sm-delivery-PrepareProof.html',
            attributes: { 'data-id': 'sm-delivery-PrepareProof' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareProof-d66e2642',
            topics: [],
        },
        {
            title: ' PrepareTarget ',
            href: 'sm-delivery-PrepareTarget.html',
            attributes: { 'data-id': 'sm-delivery-PrepareTarget' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareTarget-d66e2650',
            topics: [],
        },
        {
            title: ' PrepareTargetImpl ',
            href: 'sm-delivery-PrepareTargetImpl.html',
            attributes: { 'data-id': 'sm-delivery-PrepareTargetImpl' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrepareTargetImpl-d66e2658',
            topics: [],
        },
        {
            title: ' PreviewExtraction ',
            href: 'sm-delivery-PreviewExtraction.html',
            attributes: { 'data-id': 'sm-delivery-PreviewExtraction' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PreviewExtraction-d66e2667',
            topics: [],
        },
        {
            title: ' PrioritizeLogs ',
            href: 'sm-delivery-PrioritizeLogs.html',
            attributes: { 'data-id': 'sm-delivery-PrioritizeLogs' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrioritizeLogs-d66e2675',
            topics: [],
        },
        {
            title: ' PrioritizeTarget ',
            href: 'sm-delivery-PrioritizeTarget.html',
            attributes: { 'data-id': 'sm-delivery-PrioritizeTarget' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-PrioritizeTarget-d66e2683',
            topics: [],
        },
        {
            title: ' QueueNotification ',
            href: 'sm-delivery-QueueNotification.html',
            attributes: { 'data-id': 'sm-delivery-QueueNotification' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-QueueNotification-d66e2691',
            topics: [],
        },
        {
            title: ' RecomputeStats ',
            href: 'sm-delivery-RecomputeStats.html',
            attributes: { 'data-id': 'sm-delivery-RecomputeStats' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-RecomputeStats-d66e2699',
            topics: [],
        },
        {
            title: ' SaveUrlInfo ',
            href: 'sm-delivery-SaveUrlInfo.html',
            attributes: { 'data-id': 'sm-delivery-SaveUrlInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-SaveUrlInfo-d66e2707',
            topics: [],
        },
        {
            title: ' Stop ',
            href: 'sm-delivery-Stop.html',
            attributes: { 'data-id': 'sm-delivery-Stop' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-Stop-d66e2715',
            topics: [],
        },
        {
            title: ' StoreMirrorPageInfo ',
            href: 'sm-delivery-StoreMirrorPageInfo.html',
            attributes: { 'data-id': 'sm-delivery-StoreMirrorPageInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-StoreMirrorPageInfo-d66e2723',
            topics: [],
        },
        {
            title: ' StoreMirrorPageInfoEx ',
            href: 'sm-delivery-StoreMirrorPageInfoEx.html',
            attributes: { 'data-id': 'sm-delivery-StoreMirrorPageInfoEx' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-StoreMirrorPageInfoEx-d66e2731',
            topics: [],
        },
        {
            title: ' SubmitDelivery ',
            href: 'sm-delivery-SubmitDelivery.html',
            attributes: { 'data-id': 'sm-delivery-SubmitDelivery' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-SubmitDelivery-d66e2739',
            topics: [],
        },
        {
            title: ' SubmitDeliveryById ',
            href: 'sm-delivery-SubmitDeliveryById.html',
            attributes: { 'data-id': 'sm-delivery-SubmitDeliveryById' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-SubmitDeliveryById-d66e2747',
            topics: [],
        },
        {
            title: ' SubmitJob ',
            href: 'sm-delivery-SubmitJob.html',
            attributes: { 'data-id': 'sm-delivery-SubmitJob' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-SubmitJob-d66e2756',
            topics: [],
        },
        {
            title: ' SubmitMidSourcing ',
            href: 'sm-delivery-SubmitMidSourcing.html',
            attributes: { 'data-id': 'sm-delivery-SubmitMidSourcing' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-SubmitMidSourcing-d66e2764',
            topics: [],
        },
        {
            title: ' SubmitNotification ',
            href: 'sm-delivery-SubmitNotification.html',
            attributes: { 'data-id': 'sm-delivery-SubmitNotification' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-SubmitNotification-d66e2772',
            topics: [],
        },
        {
            title: ' UpdateBroadLogs ',
            href: 'sm-delivery-UpdateBroadLogs.html',
            attributes: { 'data-id': 'sm-delivery-UpdateBroadLogs' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-UpdateBroadLogs-d66e2780',
            topics: [],
        },
        {
            title: ' UpdateCachedDelivery ',
            href: 'sm-delivery-UpdateCachedDelivery.html',
            attributes: { 'data-id': 'sm-delivery-UpdateCachedDelivery' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-UpdateCachedDelivery-d66e2788',
            topics: [],
        },
        {
            title: ' UpdateImageConfig ',
            href: 'sm-delivery-UpdateImageConfig.html',
            attributes: { 'data-id': 'sm-delivery-UpdateImageConfig' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-UpdateImageConfig-d66e2796',
            topics: [],
        },
        {
            title: ' ValidateWavesDefinition ',
            href: 'sm-delivery-ValidateWavesDefinition.html',
            attributes: { 'data-id': 'sm-delivery-ValidateWavesDefinition' },
            menu: { hasChildren: false },
            tocID: 'sm-delivery-ValidateWavesDefinition-d66e2804',
            topics: [],
        },
    ],
};

